import React from 'react';

function CircularTooltip({ tooltipContent, children, className }) {
  return (
    <span className={`up tooltip-hover-questions padding-10px ${className}`}>
      <div className='tootip_box'> {tooltipContent} </div>
      {children}
    </span>
  );
}

export default CircularTooltip;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/VideoDisplay/CircularTooltip.jsx